import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-export-action-circle2',
    templateUrl: './export-action-circle2.component.html',
    styleUrls: [
        './export-action-circle2.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportActionCircle2Component
{
    @Input() cta: () => void;
}
